import {axiosInstance} from "@/plugins/axios";
import {Company} from "@/modules/company/types";

export async function getCompany(id: string) {
  const response = await axiosInstance.get(`companies/${id}`);
  return response.data;
}

export async function getCompanies() {
  const response = await axiosInstance.get(`companies`);
  return response.data;
}

export async function updateCompany(company: Company) {
  await axiosInstance.put(`companies/${company.id}`, {
    ...company
  });
}

